import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /aoabt4trk\.com|audienhearing\.com/.test(hostname)
// Audien's aggregate sub-id export has no conversion timestamp. It still
// depends on d=YYYYMMDD in sub3, so keep this adapter legacy until the import
// can obtain a real event date from the network.
export const compactTracking = false

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.content) {
    url.searchParams.set('sub1', params.content)
  }
  url.searchParams.set('sub2', params.pathname)
  url.searchParams.set('sub3', params.utmSearch)
  url.searchParams.set('sub4', params.term)
}
